// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Shippings from '../shippings/Shippings';
import {actions} from '../duck';
import type {RootState} from '../../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    store: state.store.store,
    isSaving: state.legalConfig.isSaving,
    shippings: state.legalConfig.shippings,
    isFetchingShippings: state.legalConfig.isFetchingShippings,
    saveShippingsSuccess: state.legalConfig.saveShippingsSuccess,
    saveShippingsError: state.legalConfig.saveShippingsError,
  }),
  (dispatch: Dispatch<any>) => bindActionCreators({...actions}, dispatch)
)(Shippings);
